





//** STORE OBSOLETO */



import { create } from 'zustand';

import { InstallScheduleData } from '@/shared/actions/erp';
import { Flota, TimeMapPlanificador } from '@/shared/interfaces/erp/mantenimiento-operaciones';

interface InstallScheduleState {
  limitDates: string[] | null; // YYYY-MM-DD
  setLimitDates: (dates: string[] | null) => void;

  timeMap: TimeMapPlanificador[] | null;
  setTimeMap: (timeMap: TimeMapPlanificador[] | null) => void;

  selectedHour: string | null;
  setSelectedHour: (hour: string | null) => void;
  selectedDate: string | null;
  setSelectedDate: (date: string | null) => void;

  allTimeMaps: TimeMapPlanificador[] | null;
  setAllTimeMaps: (data: TimeMapPlanificador[] | null) => void;

  clearAll: () => void;

  hasStartedTimer: boolean;
  setHasStartedTimer: (value: boolean) => void;

  isFormBlocked: boolean;
  setIsFormBlocked: (value: boolean) => void;

  cacheHorarioData: InstallScheduleData | null;
  setCacheHorarioData: (data: InstallScheduleData | null) => void;

  dateTimeInstallation: string | null;
  setDateTimeInstallation: (date: string | null) => void;

  isVisibleCalendario: boolean;
  setIsVisibleCalendario: (value: boolean) => void;

  thereIsCacheData: boolean;
  setThereIsCacheData: (value: boolean) => void;

  selectedFlota: Flota | null;
  setSelectedFlota: (flota: Flota | null) => void;

  clearFinal: () => void;
}

export const useInstallScheduleStore = create<InstallScheduleState>(set => ({
  timeMap: null,
  setTimeMap: timeMap => set({ timeMap }),

  limitDates: null,
  setLimitDates: dates => set({ limitDates: dates }),

  selectedHour: null,
  setSelectedHour: hour => set({ selectedHour: hour }),
  selectedDate: null,
  setSelectedDate: date => set({ selectedDate: date }),

  allTimeMaps: null,
  setAllTimeMaps: data => set({ allTimeMaps: data }),

  clearAll: () =>
    set({
      timeMap: null,
      limitDates: null,
      selectedHour: null,
      allTimeMaps: null,

      selectedDate: null,
      cacheHorarioData: null,
      hasStartedTimer: false,
      isFormBlocked: false,
    }),

  clearFinal: () =>
    set({
      isVisibleCalendario: false,
      thereIsCacheData: false,
      selectedFlota: null,
    }),

  hasStartedTimer: false,
  setHasStartedTimer: value => set({ hasStartedTimer: value }),

  isFormBlocked: false,
  setIsFormBlocked: value => set({ isFormBlocked: value }),

  cacheHorarioData: null,
  setCacheHorarioData: data => set({ cacheHorarioData: data }),

  dateTimeInstallation: null,
  setDateTimeInstallation: date => set({ dateTimeInstallation: date }),

  //
  isVisibleCalendario: false,
  setIsVisibleCalendario: value => set({ isVisibleCalendario: value }),
  thereIsCacheData: false,
  setThereIsCacheData: value => set({ thereIsCacheData: value }),
  selectedFlota: null,
  setSelectedFlota: flota => set({ selectedFlota: flota }),
}));
